import api from '../../services/api';

export const loginRequest = (data) => api.post('login/', data);
export const logoutRequest = () => api.post('/logout/', null);
